module.exports = __webpack_public_path__ + "img/T5-D-xh_5.537d1bce.png";